module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_c('span', {
    staticClass: "lineh"
  }, [_vm._v("seasonal")])])]), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "lineh1"
  }, [_vm._v("plant")])]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("dyes")]), _vm._v(" "), _c('p', {
    staticClass: "titleSub"
  }, [_vm._v("Create your own beautiful botanical dyes,"), _c('br'), _vm._v("plus four seasonal projects to make")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ALICIA HALL")])]), _vm._v(" "), _c('p', {
    staticClass: "author2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Photographs by Alicia Hall")])]), _vm._v(" "), _c('div', {
    staticClass: "pub"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/pub.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c0d47ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Title.vue
// module id = 60
// module chunks = 0